Object.size = function(obj) {
  var size = 0, key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};

Object.isEmpty = function ( obj ) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

Object.clone = function ( obj ) {
  return jQuery.extend ( true, {}, obj );
};